import { useMutation } from "@tanstack/react-query";
import { updateDigitalTwinApi } from "@/API/updateDigitalTwinApi";
import { ShowNotification } from "@/components/ShowNotification";

export const useUpdateDigitalTwin = () => {
  return useMutation<any, Error, any>({
    mutationFn: (data) => updateDigitalTwinApi(data),
    onSuccess: () => {
      ShowNotification({
        title: "Success",
        message: "Digital Twin updated successfully!",
        color: "success",
      });
    },
    onError: () => {
      ShowNotification({
        title: "Error",
        message: "Failed to update the Digital Twin.",
        color: "error",
      });
    },
  });
};
